import { render, staticRenderFns } from "./VerPrestamo.vue?vue&type=template&id=876336bc&scoped=true"
import script from "./VerPrestamo.vue?vue&type=script&lang=js"
export * from "./VerPrestamo.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./VerPrestamo.vue?vue&type=style&index=1&id=876336bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876336bc",
  null
  
)

export default component.exports